module.exports = __webpack_public_path__ + "static/media/kyc-check-xumm.f9ac67ec.svg";